export const POPULAR_SERVICES_LIST: string[] = [
  'bathroom',
  'kitchen',
  'storage',
  '1063',
  'filter-systems',
  '331',
  '323',
  '337',
  '334',
];

export const KZ_POPULAR_SERVICES_LIST: string[] = ['bathroom', 'kitchen', 'storage', 'windows', 'ceilings'];
